import { frontendURL } from 'dashboard/helper/URLHelper';
import PipelineKanban from './pages/PipelineKanban.vue';

const pipelineRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/pipeline'),
      name: 'pipeline_kanban',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: PipelineKanban,
    },
  ],
};

export default pipelineRoutes;
